export const server = "https://rentalsapi.onrender.com/api/v2";

export const backend_url = "https://rentalsapi.onrender.com/";
